import { render, staticRenderFns } from "./common-button.vue?vue&type=template&id=5853485e&scoped=true"
import script from "./common-button.vue?vue&type=script&lang=js"
export * from "./common-button.vue?vue&type=script&lang=js"
import style0 from "./common-button.vue?vue&type=style&index=0&id=5853485e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5853485e",
  null
  
)

export default component.exports